import { Observable } from 'rxjs'
import { push } from 'react-router-redux'
import { apiUrl } from '../config/settings'
import { authTypes, teamTypes, participantTypes, generalTypes } from '../actions'
import { Headers, Auth } from '../helpers'

export const getInitDataEpic = (action$) => {
  return action$.ofType(generalTypes.GET_INIT_DATA)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/general/`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: generalTypes.INIT_DATA_RES, payload: res.response }))
        .catch(err => {
          if (err.status === 401) {
            return Observable
              .create(obs => {
                Auth.deauthenticateUser()
                obs.next({ type: authTypes.FAIL })
                obs.next(push('/login'))
                obs.complete()
              })
          }
        })
    })
}

export const initDataResEpic = (action$) => {
  return action$.ofType(generalTypes.INIT_DATA_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { user, teams, participants, schedules } = action.payload
            Auth.authenticateUser(Auth.getToken(), user)
            obs.next({ type: authTypes.SUCCESS, user: user })
            obs.next({ type: generalTypes.SAVE_SCHEDULES, schedules })
            obs.next({ type: teamTypes.GET_ALL_RESPONSE, payload: { success, teams } })
            obs.next({ type: participantTypes.SAVE, participants })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Loading data was unsuccessfull.' })
          }
          obs.complete()
        })
        .catch(err => console.log(err))
    })
}

export const getAdminDataEpic = (action$) => {
  return action$.ofType(generalTypes.ADMIN_INIT)
    .switchMap(action => {
      let city = action.city || Auth.getLocation()
      return Observable
        .ajax(
          {
            url: `${apiUrl}/admin/${city}`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: generalTypes.ADMIN_INIT_RES, payload: res.response }))
        .catch(err => {
          if (err.status === 401) {
            return Observable
              .create(obs => {
                Auth.deauthenticateUser()
                obs.next({ type: authTypes.FAIL })
                obs.next(push('/login'))
                obs.complete()
              })
          }
        })
    })
}

export const adminDataResEpic = (action$) => {
  return action$.ofType(generalTypes.ADMIN_INIT_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { teams, participants } = action.payload
            obs.next({ type: teamTypes.GET_ALL_RESPONSE, payload: { success, teams } })
            obs.next({ type: participantTypes.SAVE, participants })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Loading data was unsuccessfull.' })
          }
          obs.complete()
        })
        .catch(err => console.log(err))
    })
}



// WEBPACK FOOTER //
// ./src/epics/general.js